//import EVENTS     from '../../constants/common_events.constants';

export class XrayLoginController {

    constructor(AuthDao, XrayOnboardingDao, $interval, $timeout, JFrogModal, $state, $scope, $stateParams, $rootScope,
            $q,
            User, $location, $window, XRayUIState, JFrogEventBus, JFrogNotifications, InitialConfigurationModal,
            XRayUIStorage, XRayUIWebsocketInterface, SaasDao) {
        this.user = {};
        this.rememberMe = false;
        this.UserService = User;
        this.$state = $state;
        this.AuthDao = AuthDao;
        this.$stateParams = $stateParams;
        this.SaasDao = SaasDao;
        this.$rootScope = $rootScope;
        this.XRayUIWebsocketInterface = XRayUIWebsocketInterface;
        this.onboardingDao = XrayOnboardingDao;
        this.$interval = $interval;
        this.$timeout = $timeout;
        this.XRayUIStorage = XRayUIStorage;
        //this.$scope = $scope;
        this.$q = $q;
        this.$window = $window;
        this.jfrogEventBus = JFrogEventBus;
        this.jfrogNotifications = JFrogNotifications;
        this.$location = $location;
        this.xRayUIState = XRayUIState;
        this.initialConfigurationModal = InitialConfigurationModal;
        this.canResetPassword = false;
        this.canRememberMe = false;
        this.canRememberMe = false;
        this.loginForm = null;
        this.pending = false;
        this.modal = JFrogModal;
        this.user.user = $stateParams.username;
        this.$scope = $scope;
        //console.log('checking migration status');
        this.tokenAuth = false;
        this.checkSaas()
        this.$timeout(() => {
            this.checkMigrationStatus();
        }, 500);
        $scope.$on('$destroy', () => {
            if (this.isLongPooling === true) {
                this.cancelLongPooling();
                this._destroyAnimationListeners();
            }
        });

        this.AuthDao.saml_login({$no_spinner: true}, {}).$promise.then((data) => {
            if (data.ssoProviderLink) {
                this.ssoProviderLink = data.ssoProviderLink;
            }
            if (data.autoLoginSml && !this.$location.search().token && !this.xRayUIState.getState(
                    'userLogout') && this.xRayUIState.getState('urlAfterLogin')) {
                this.ssoLogin();
            }

            if (this.xRayUIState.getState('userLogout')) {
                this.xRayUIState.removeState('userLogout');
            }
        });


        if (this.$location.search().token) {
            this.tokenAuth = true;
            this.login();
        }
    }

    checkSaas() {

        this.SaasDao.get().$promise.then((data) => {

            console.log("The Saas Status is", data);
            if (data.is_saas_service && !data.is_completed) {
                console.log("Moving to splash")
                this.$state.go('splash');
            }

        });
    }

    login() {


        this.onboardingDao.getMigrationStatus().$promise.then((data) => {

            if (data.isDbMigrationRunning) {
                if (!this.isLongPooling) {
                    this.showMigrationModal();
                    this.poolMigrationStatus();
                    this.$timeout(() => {
                        this._createAnimation();
                    });
                }
            } else {

                if (this.loginForm.$valid && !this.pending) {
                    this.pending = true;
                    this.UserService.login(this.user.user, this.user.password, this.rememberMe).then(success.bind(this),
                            error.bind(this));
                } else if (this.tokenAuth) {
                    this.UserService.login(this.user.user, this.user.password, this.rememberMe, this.tokenAuth).then(
                            success.bind(this), error.bind(this));
                }

                function success(result) {
                    this.pending = false;
                    if (!result.error) {
                        this.user = result;
                        this.hidden = true;
                        this.initialConfigurationModal.isSystemConfigured().then((configured) => {
                            if (configured) {
                                this.exitLoginState();
                            }
                            else {
                                if (this.initialConfigurationModal.show()) {
                                    this.XRayUIWebsocketInterface.connect();
                                    this.initialConfigurationModal.show().then(() => this.exitLoginState());
                                }

                            }
                        });
                    }
                    else {
                        this.errorMessage = result.error;
                    }
                }


                function error(response) {
                    this.pending = false;
                    if (response.data) {
                        if (!this.catchExpired(response)) {
                            this.errorMessage = response.data.error;
                        }
                    }
                }
            }
        });
    }

    exitLoginState() {
        if (this.$rootScope.jfSidebar) {
            this.$rootScope.jfSidebar.refreshMenu();
        }
        let urlAfterLogin = this.xRayUIState.getState('urlAfterLogin');
        if (urlAfterLogin && !(urlAfterLogin.startsWith('/admin') && !this.user.admin)) {
            let params = this.xRayUIState.getState('urlAfterLoginParams');
            if (params) {
                this.$location.path(urlAfterLogin).search(params);
            } else {
                this.$location.path(urlAfterLogin);
            }

        }
        else {
            this.$state.go('home');
        }
    }

    catchExpired(response) {
        let code = 'CREDENTIALS_EXPIRED';
        if (response.data && response.data.code && response.data.code === code) {
            let msg = response.data.feedbackMsg.error;
            if (response.data.profileUpdatable) {
                this.$state.go('change-password', {username: this.user.user});
            }
            else {
                msg += '.\nPlease contact your system administrator.';
                this.jfrogNotifications.create({error: msg});
            }
            return true;
        }
        return false;
    }

    userPasswordChanged() {
        this.errorMessage = null;
    }


    checkResetPassword() {
        this.UserService.getLoginData().then((response) => {
            this.canResetPassword = response.forgotPassword;
            this.canRememberMe = response.canRememberMe;
            this.ssoProviderLink = response.ssoProviderLink;
            this.oauthProviderLink = response.oauthProviderLink;
        });
    }

    gotoForgotPwd() {
        this.$state.go('forgot-password');
    }

    /*
     oauthLogin() {
     this.$window.open(this.oauthProviderLink,'_self');
     }
     */

    ssoLogin() {
        this.xRayUIState.removeState('userLogout');
        this.$window.open(this.ssoProviderLink, '_self');
    }

    isOAuthEnabled() {
        return;
    }

    onGotoOAuth() {
        localStorage.stateBeforeOAuth = this.$state.current.name;
    }


    poolMigrationStatus() {
        this.isLongPooling = true;
        this.longPooling = this.$interval(() => {
            this.checkMigrationStatus();
        }, 10000);
    }


    cancelLongPooling() {
        //console.log('stopping long pooling!');
        this.$interval.cancel(this.longPooling);
        this.isLongPooling = false;
    }

    checkMigrationStatus() {
        this.onboardingDao.getMigrationStatus().$promise.then((data) => {


            if (data.error) {

                this.migrationError = data.error;
                this.errorStyle = {height: '165px', padding: '20px'};
                if (this.modalRunning) {
                    this.$interval.cancel(this.longPooling);
                }
            }
            if (data.isDbMigrationRunning) {
                if (!this.ORIGINAL_TOTAL_MIGRATIONS) {
                    this.ORIGINAL_TOTAL_MIGRATIONS = data.total;
                }
                this.CURRENT_FINISHED_MIGRATIONS = this.ORIGINAL_TOTAL_MIGRATIONS - data.total;

                //console.log('ORIGINAL:', this.ORIGINAL_TOTAL_MIGRATIONS, 'Current : ',
                // this.CURRENT_FINISHED_MIGRATIONS)
                let current = this.ORIGINAL_TOTAL_MIGRATIONS - this.CURRENT_FINISHED_MIGRATIONS;
                let total = this.ORIGINAL_TOTAL_MIGRATIONS;
                this.totalFinishedMigrations = total - current;
                //console.log('Progressing: , ', ( this.totalFinishedMigrations / total) * 100)
                let percent = ((this.totalFinishedMigrations / total) * 100).toFixed(0) + '%';
                if ((this.totalFinishedMigrations / total) * 100 < 1) {
                    percent = '5%';
                }
                this.progressBar = percent;

                if (isNaN(((this.totalFinishedMigrations / total) * 100).toFixed(0))) {
                    this.progressBar = '0%';
                }
                if (!this.isLongPooling) {
                    this.showMigrationModal();
                    if (!data.error) {
                        this.poolMigrationStatus();
                    }
                    this.$timeout(() => {
                        this._createAnimation();
                    });
                }
            } else {
                //console.log('Migration isnt running');
                this.totalFinishedMigrations = this.ORIGINAL_TOTAL_MIGRATIONS;
                this.progressBar = '100%';
                if (this.isLongPooling) {
                    this.cancelLongPooling();
                    //console.log('reloading state');
                    this.$timeout(() => {
                        this.$state.reload();
                    }, 3000);
                }
            }
        });
    }

    showMigrationModal() {
        let modalScope = this.$scope.$new();
        this.modalscopeTmp = modalScope;
        modalScope.title = 'TestTitle';
        let modalInstance = '';
        modalInstance = this.modal.launchModal('migration_modal', modalScope, null, false);
        this.modalRunning = true;

    }

    _createAnimation() {
        this._destroyAnimationListeners();
        var canvas, stage, exportRoot;

        canvas = document.getElementById('canvas');
        exportRoot = new lib.jfrog_v45_Html_5();

        stage = new createjs.Stage(canvas);
        stage.addChild(exportRoot);
        stage.update();

        createjs.Ticker.setFPS(lib.properties.fps);
        createjs.Ticker.addEventListener('tick', stage);

    }

    _destroyAnimationListeners() {
        createjs.Ticker.removeAllEventListeners();
    }
}



// WEBPACK FOOTER //
// ./modules/xray/states/login/login.controller.js